import { render, staticRenderFns } from "./ContractEditor.vue?vue&type=template&id=206bc13c&scoped=true"
import script from "./ContractEditor.vue?vue&type=script&lang=js"
export * from "./ContractEditor.vue?vue&type=script&lang=js"
import style0 from "./ContractEditor.vue?vue&type=style&index=0&id=206bc13c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206bc13c",
  null
  
)

export default component.exports